import { History, Loader2, MessageSquareText } from "lucide-react";

const DAY = 86400000;

function groupLabel(iso) {
  const d = new Date(iso);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diff = today - new Date(d.getFullYear(), d.getMonth(), d.getDate());
  if (diff <= 0) return "Today";
  if (diff <= DAY) return "Yesterday";
  if (diff <= 7 * DAY) return "Previous 7 days";
  if (diff <= 30 * DAY) return "Previous 30 days";
  return "Older";
}

function groupSessions(sessions) {
  const groups = [];
  sessions.forEach((s) => {
    const label = groupLabel(s.created_at);
    const last = groups[groups.length - 1];
    if (last && last.label === label) last.items.push(s);
    else groups.push({ label, items: [s] });
  });
  return groups;
}

const timeOf = (iso, label) =>
  new Date(iso).toLocaleString([], label === "Today" || label === "Yesterday" ? { timeStyle: "short" } : { month: "short", day: "numeric" });

export function HistoryPanel({ sessions, loading, activeId, onOpen, openingId, inSheet = false }) {
  const groups = groupSessions(sessions);
  return (
    <div className="flex flex-col h-full min-h-0" data-testid="history-panel">
      <div className={`px-4 py-3 border-b border-[#E1E3E5] bg-white flex items-center gap-2 shrink-0 ${inSheet ? "pr-12" : ""}`}>
        <History className="h-4 w-4 text-[#005180]" />
        <span className="font-semibold text-sm text-[#202223]">Recent conversations</span>
      </div>
      <div className="flex-1 overflow-y-auto p-2" data-testid="history-list">
        {loading && sessions.length === 0 && (
          <div className="flex justify-center py-8"><Loader2 className="h-4 w-4 animate-spin text-[#6D7175]" /></div>
        )}
        {!loading && sessions.length === 0 && (
          <div className="text-center text-sm text-[#6D7175] px-4 py-10" data-testid="history-empty">
            <MessageSquareText className="h-6 w-6 mx-auto mb-2 text-[#8C9196]" />
            Your conversations from the last 3 months will appear here.
          </div>
        )}
        {groups.map((g) => (
          <div key={g.label} className="mb-3">
            <div className="px-2 pt-2 pb-1 text-[11px] font-semibold text-[#6D7175]">{g.label}</div>
            {g.items.map((s) => {
              const active = s.id === activeId;
              return (
                <button key={s.id} type="button" onClick={() => onOpen(s.id)} data-testid={`history-item-${s.id}`}
                  className={`w-full text-left rounded-lg px-2.5 py-2 transition-colors flex items-start gap-2 ${
                    active ? "bg-white shadow-[0_1px_2px_rgba(0,0,0,0.08)] ring-1 ring-[#1E7FC2]/30" : "hover:bg-[#E9EAEC]"}`}>
                  <span className="min-w-0 flex-1">
                    <span className={`block text-[13px] leading-5 line-clamp-2 ${active ? "font-semibold text-[#05304F]" : "text-[#303030]"}`}>{s.title}</span>
                    <span className="block text-[11px] text-[#8C9196] mt-0.5">{timeOf(s.created_at, g.label)}</span>
                  </span>
                  {openingId === s.id && <Loader2 className="h-3.5 w-3.5 mt-0.5 animate-spin text-[#6D7175] shrink-0" />}
                </button>
              );
            })}
          </div>
        ))}
      </div>
      <div className="px-4 py-2.5 border-t border-[#E1E3E5] text-[11px] text-[#8C9196] shrink-0">Kept for 3 months for compliance.</div>
    </div>
  );
}
